import linkCollaborationProfilesCaptions from "~assets/nadia-tutorial/link-collaboration-profiles.en.vtt";
import linkCollaborationProfiles from "~assets/nadia-tutorial/link-collaboration-profiles.mp4";
import linkCollaborationProfilesPoster from "~assets/nadia-tutorial/link-collaboration-profiles-poster.webp";
import readWeeklyInsightsCaptions from "~assets/nadia-tutorial/read-your-weekly-insights.en.vtt";
import readWeeklyInsights from "~assets/nadia-tutorial/read-your-weekly-insights.mp4";
import readWeeklyInsightsPoster from "~assets/nadia-tutorial/read-your-weekly-insights-poster.webp";
import turnInsightsIntoActionCaptions from "~assets/nadia-tutorial/turn-insights-into-action.en.vtt";
import turnInsightsIntoAction from "~assets/nadia-tutorial/turn-insights-into-action.mp4";
import turnInsightsIntoActionPoster from "~assets/nadia-tutorial/turn-insights-into-action-poster.webp";
import { Duration } from "luxon";

export interface WalkthroughVideo {
    id: string;
    title: string;
    feature: string;
    durationSeconds: number;
    src: string;
    poster: string;
    captions: string;
}

export const walkthroughVideos: WalkthroughVideo[] = [
    {
        id: "read_weekly_insights",
        title: "Read your weekly insights",
        feature: "My Work",
        durationSeconds: 93,
        src: readWeeklyInsights,
        poster: readWeeklyInsightsPoster,
        captions: readWeeklyInsightsCaptions,
    },
    {
        id: "link_collaboration_profiles",
        title: "Link your collaboration profiles",
        feature: "Collaboration Profiles",
        durationSeconds: 62,
        src: linkCollaborationProfiles,
        poster: linkCollaborationProfilesPoster,
        captions: linkCollaborationProfilesCaptions,
    },
    {
        id: "turn_insights_into_action",
        title: "Turn insights into action",
        feature: "My Work",
        durationSeconds: 95,
        src: turnInsightsIntoAction,
        poster: turnInsightsIntoActionPoster,
        captions: turnInsightsIntoActionCaptions,
    },
];

export function formatDuration(seconds: number): string {
    return Duration.fromObject({ seconds }).toFormat("m:ss");
}
